import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { login } from '../lib/auth';

export const Route = createFileRoute('/login')({ component: LoginPage });

function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    try {
      await login(email, password);
      window.location.assign('/');
    } catch {
      setErr('Hatalı e-posta veya şifre.');
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-sm flex-col justify-center p-6">
      <h1 className="mb-6 text-2xl font-bold">Giriş</h1>
      <form onSubmit={submit} className="space-y-3">
        <input type="email" placeholder="E-posta" value={email} autoFocus
               onChange={(e) => setEmail(e.target.value)}
               className="w-full rounded bg-neutral-800 p-2" />
        <input type="password" placeholder="Şifre" value={password}
               onChange={(e) => setPassword(e.target.value)}
               className="w-full rounded bg-neutral-800 p-2" />
        {err && <p className="text-sm text-red-400">{err}</p>}
        <button className="w-full rounded bg-brand-500 p-2 font-medium hover:bg-brand-600">
          Giriş
        </button>
      </form>
    </main>
  );
}
